import { APIStoreProps } from "../stores-interface";
import {
    LocationProps,
    APILocationProps,
    GeocodedResultsProps,
    APIGeocodedResultsProps,
} from "./location-interface";

export const transformCategoryStoreLocations = (
    locations: Array<APILocationProps>,
    includedStores: Array<APIStoreProps> = []
): Array<LocationProps> => {
    const includedStoreDict: { [id: string]: APIStoreProps } = includedStores.reduce(
        (accum, store) => ({
            ...accum,
            [store.id]: store,
        }),
        {}
    );

    return locations.map((location) => {
        const relatedStoreId = String(location.relationships.store.data.id);
        const includedStore = includedStoreDict[relatedStoreId];
        return {
            id: location.id,
            shopName: location.attributes.shop_name,
            fullAddress: location.attributes.full_address,
            latitude: location.attributes.latitude,
            longitude: location.attributes.longitude,
            distanceToUser: location.attributes.distance_to_user,
            storeId: location.relationships.store.data.id,
            mainImageUrl: includedStore.attributes.main_image_url,
            newLogoUrl:
                includedStore.attributes.avatar_url ||
                includedStore.attributes.new_logo_url ||
                includedStore.attributes.logo_url,
            shopUrl: includedStore.attributes.shop_url,
            storeName: includedStore.attributes.name,
        };
    });
};

export const transformStoreLocations = (
    locations: Array<APILocationProps>,
    includedStore: APIStoreProps
): Array<LocationProps> => {
    return locations.map((location) => ({
        id: location.id,
        shopName: location.attributes.shop_name,
        fullAddress: location.attributes.full_address,
        latitude: location.attributes.latitude,
        longitude: location.attributes.longitude,
        distanceToUser: location.attributes.distance_to_user,
        storeId: location.relationships.store.data.id,
        mainImageUrl: includedStore.attributes.main_image_url,
        newLogoUrl: includedStore.attributes.avatar_url,
        storeName: includedStore.attributes.name,
        shopUrl: includedStore.attributes.shop_url,
    }));
};

export const transformGeocodedLocations = (
    results: APIGeocodedResultsProps
): GeocodedResultsProps => {
    return {
        northeastBounds: results.geometry.bounds.northeast,
        southwestBounds: results.geometry.bounds.southwest,
        postcodeLocalities: results.postcode_localities,
        location: results.geometry.location,
    };
};
